/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';
import styles from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel.module.scss';
import Moment from 'react-moment';

@translate()
export default class AssetOpportunity extends React.Component<*> {
  render(): React.Element<*> {
    const { t, data } = this.props;
    const { asset, contact_details } = data.details;
    return (
      <div>
        <DetailsPanel data={data} assetTitle={t('general:assets.labels.details')} />

        <div className={styles['details-panel']}>
          <div className={styles['container']}>
            <div className={styles['list-container']}>
              <b>{t('general:sent_requests.opportunity_details')}</b>
              <ul>
                <li>
                  {t('general:assets.labels.consignment_sale')}:{' '}
                  {asset.consignment_sale ? 'Yes' : 'No'}
                </li>
                <li>
                  {t('general:assets.labels.sub-rental')}: {asset.subrental ? 'Yes' : 'No'}
                </li>
              </ul>
            </div>

            <div className={styles['list-container']}>
              <b>{t('general:assets.labels.details')}</b>
              <ul>
                <li>
                  {t('general:assets.labels.number')}:{' '}
                  <Link to={`/assets/${asset.id}`}>{asset.asset_number}</Link>
                </li>
                <li>
                  {t('general:manufacturer')}: {asset.manufacturer}
                </li>
                <li>
                  {t('general:model')}: {asset.model}
                </li>

                <li>
                  {t('general:labels.serial_number')}: {asset.serial_number}
                </li>

                <li>
                  {t('general:assets.labels.options_fitted')}:{' '}
                  {asset.options_fitted ? asset.options_fitted : 'N/A'}
                </li>
                <li>
                  {t('general:assets.labels.calibration_status')}: {asset.er_calibration_status}
                </li>
                <li>
                  {t('general:calibrations.labels.due_date')}:{' '}
                  {asset.er_calibration_due_date ? (
                    <Moment date={asset.er_calibration_due_date} format="MMMM DD, YYYY" />
                  ) : (
                    'N/A'
                  )}
                </li>
              </ul>
            </div>

            <div className={styles['list-container']}>
              <b>{t('general:labels.contact_details')}</b>
              <ul>
                <li>
                  {t('general:labels.contact_name')}: {contact_details.name}
                </li>
                <li>
                  {t('general:labels.contact_email')}: {contact_details.email}
                </li>
                <li>
                  {t('general:trading_account_s')}: {contact_details.accounts.join(', ')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
